/** API route map: URLS.Controller.CandidateResume */
export const CandidateResume = {
      Name: 'CandidateResume/',
      GetAll: 'candidate-resumes',
      Add: 'add',
      DeleteResume: 'delete',
};
